__webpack_require__.p = "/react-badminton-organizer/";